module.exports = __webpack_public_path__ + "img/registration-icon.9bba0f5f.svg";